// extracted by mini-css-extract-plugin
export var dividerLine = "_84-3";
export var itemImage = "_84-9";
export var lightDivider = "_84-4";
export var modalContent = "_84-5";
export var modalContentCompact = "_84-6";
export var productCard = "_84-a";
export var productImage = "_84-b";
export var productImageCompact = "_84-7";
export var productImagePlaceholder = "_84-c";
export var productImagePlaceholderCompact = "_84-8";
export var progressBarBackground = "_84-1";
export var progressBarContainer = "_84-0";
export var progressBarFill = "_84-2";